import { AppProductionConfigs, PaymentTypes, UILayout } from '../constants/AppConstants';
var defaultConfig = {
  country: 'US',
  paymentMethods: [PaymentTypes.PAYPAL, PaymentTypes.APPLEPAY, PaymentTypes.CREDITCARD, PaymentTypes.VENMO, PaymentTypes.GOOGLE_PAY],
  yiftee: {
    yifteeCoveringFull: false,
    balance: -1
  },
  ui: {
    layout: UILayout.FULL,
    showSubmitButton: false,
    validate3rdPartyAddr: false,
    displayServerErrors: true,
    displayLoadingIndicator: true
  },
  submit: false,
  // to be replaced with command framework
  didAddressUpdate: false,
  applepayVisible: true,
  venmoVisible: true,
  googlepayVisible: false,
  regexValidation: true,
  authorization: {
    apiKey: '',
    cheggBaseUrl: 'https://www.chegg.com'
  },
  appConstants: AppProductionConfigs,
  mandatoryCountries: [''],
  hiddenCountries: [''],
  showHeading: false,
  headingText: '',
  // Payment information,
  productFamily: undefined
};
export default defaultConfig;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/config/defaultConfig.js
// module id = 4367
// module chunks = 11